import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export interface CellMeteringPoint {
    id: number;
    eic: string;
}

export function MeteringPointCell({ meteringPoints, id }: { meteringPoints: CellMeteringPoint[], id: number }) {

    const allMeteringPoints = meteringPoints.map(mp => <small className="d-block line-height-1" key={mp.eic}>{mp.eic}</small>);
    if (meteringPoints.length < 4) {
        return (
          <>
              { allMeteringPoints }
          </>
        );
    }
    const sliced = meteringPoints.slice(0, 3);
    const hidden = meteringPoints.slice(3);

    return (
        <>
            <OverlayTrigger delay={250}
                overlay={
                    <Tooltip id={`tooltip-mp-${id}`}>
                        <>
                        { allMeteringPoints }
                        </>
                    </Tooltip>
                }
                placement={"top"}
            >
                <div>
                    { sliced.map(mp => <small className="d-block line-height-1 text-nowrap" key={mp.eic}>{mp.eic}</small>) }
                    <small className="d-block line-height-1">...ja veel {hidden.length}</small>                
                </div>
            </OverlayTrigger>

        </>
    );
}